module.exports = __webpack_public_path__ + "img/daniel-sign .8c2d09be.png";